import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../home/components/Footer";
import { services } from "../../mocks/homeData";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function ServicesPage() {
  usePageMeta({
    title: "Hizmetler | Hangar Muhendislik",
    description:
      "Hangar, fabrika, depo ve celik konstruksiyon odakli muhendislik ve uygulama hizmetleri.",
  });

  return (
    <div className="font-body antialiased">
      <Navbar />
      <main>
        {/* Hero Banner */}
        <section className="relative h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden bg-navy">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33"
              alt="Çelik Konstrüksiyon Arkaplan"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-navy/70 via-navy/50 to-navy/70" />
          <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 text-center">
            <div className="inline-block w-12 h-1 rounded-full bg-copper mb-6" />
            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4">
              Hizmetlerimiz
            </h1>
            <p className="font-body text-base md:text-lg text-white/70 max-w-2xl mx-auto">
              Endüstriyel yapıdan çelik konstrüksiyona kadar tüm mühendislik çözümleriniz için yanınızdayız.
            </p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="bg-white py-16 md:py-24 lg:py-32">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {services.map((service) => (
                <div
                  key={service.id}
                  className="group bg-white rounded-lg overflow-hidden border border-gray-200 hover:border-copper/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl"
                >
                  <div className="relative h-52 md:h-56 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
                  </div>
                  <div className="p-5 md:p-6">
                    <h3 className="font-heading font-bold text-lg md:text-xl text-navy mb-2 md:mb-3">
                      {service.title}
                    </h3>
                    <p className="font-body text-sm text-gray-600 leading-relaxed mb-4">
                      {service.description}
                    </p>
                    <div className="flex items-center gap-4">
                      <Link
                        to={`/hizmetler/${service.slug}`}
                        className="inline-flex items-center gap-2 font-body text-sm font-medium text-navy hover:text-copper transition-colors group/link"
                      >
                        Detaylı Bilgi
                        <div className="w-4 h-4 flex items-center justify-center group-hover/link:translate-x-1 transition-transform">
                          <i className="ri-arrow-right-line" />
                        </div>
                      </Link>
                      <Link
                        to="/iletisim"
                        className="inline-flex items-center gap-2 font-body text-sm font-medium text-copper hover:text-copper-dark transition-colors group/link"
                      >
                        Teklif Al
                        <div className="w-4 h-4 flex items-center justify-center group-hover/link:translate-x-1 transition-transform">
                          <i className="ri-arrow-right-line" />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-gray-50 py-16 md:py-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-navy mb-4">
              Projeniz için doğru çözümü arıyorsunuz?
            </h2>
            <p className="font-body text-base text-gray-600 mb-8 max-w-xl mx-auto">
              Uzman ekibimizden projenize özel danışmanlık ve fiyat teklifi almak için hemen iletişime geçin.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 bg-copper hover:bg-copper-dark text-white font-body text-sm font-medium px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap"
            >
              Ücretsiz Teklif Al
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
